/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meal_LunchInputs */

const en_meal_lunch = /** @type {(inputs: Meal_LunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunch`)
};

const de_meal_lunch = /** @type {(inputs: Meal_LunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagessen`)
};

/**
* | output |
* | --- |
* | "Lunch" |
*
* @param {Meal_LunchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const meal_lunch = /** @type {((inputs?: Meal_LunchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meal_LunchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_meal_lunch(inputs)
	return en_meal_lunch(inputs)
});